import { AgTableClient } from "app/shared/AgTable";
import PageHeader from "app/shared/PageHeader";
import React from "react";

const IdeationPortal = () => {


    const COLUMN_DEFS = [
        {
            headerName: "Invoice Number",
            field: "invoice_number",
            filter: "agTextColumnFilter",
            enableRowGroup: true,
            enablePivot: true
        },
        {
            headerName: "Parsed Invoice Number",
            field: "parsed_invoice_number",
            filter: "agTextColumnFilter",
            enableRowGroup: true,
            enablePivot: true
        },
        {
            headerName: "Workspace",
            field: "workspace",
            filter: "agTextColumnFilter",
            enableRowGroup: true,
            enablePivot: true
        },
        {
            headerName: "Invoice Date",
            field: "invoice_date",
            filter: "agDateColumnFilter",
            filterParams: {
                comparator: (filterLocalDateAtMidnight: any, cellValue: any) => {
                    if (!cellValue) return -1;
                    const cellDate = new Date(cellValue);
                    // Strip time part to compare only dates
                    const cellDateNoTime = new Date(
                        cellDate.getFullYear(),
                        cellDate.getMonth(),
                        cellDate.getDate()
                    );
                    if (cellDateNoTime.getTime() === filterLocalDateAtMidnight.getTime()) {
                        return 0;
                    }
                    return cellDateNoTime < filterLocalDateAtMidnight ? -1 : 1;
                },
            },
            valueFormatter: (params: any) => {
                if (!params.value) return "";
                const date = new Date(params.value);
                // format as DD/MM/YYYY for display
                const day = String(date.getDate()).padStart(2, "0");
                const month = String(date.getMonth() + 1).padStart(2, "0");
                const year = date.getFullYear();
                return `${day}/${month}/${year}`;
            },
        },
        {
            headerName: "Client GST Number",
            field: "client_gst_number",
            filter: "agTextColumnFilter",
            enableRowGroup: true,
            enablePivot: true
        },
        {
            headerName: "Hotel GST Number",
            field: "hotel_gst_number",
            filter: "agTextColumnFilter",
            enableRowGroup: true,
            enablePivot: true
        },
        {
            headerName: "Asset Link",
            field: "asset_link",
            filter: "agTextColumnFilter",
            cellRenderer: (params: any) =>
                params.value ? (
                    <a href={params.value} target="_blank" rel="noopener noreferrer">
                        View
                    </a>
                ) : (
                    ""
                ),
            enableRowGroup: true,
            enablePivot: true
        },
        {
            headerName: "Checkout Date",
            field: "checkout_date",
            filter: "agDateColumnFilter",
            filterParams: {
                comparator: (filterLocalDateAtMidnight: any, cellValue: any) => {
                    if (!cellValue) return -1;
                    const cellDate = new Date(cellValue);
                    // Strip time part to compare only dates
                    const cellDateNoTime = new Date(
                        cellDate.getFullYear(),
                        cellDate.getMonth(),
                        cellDate.getDate()
                    );
                    if (cellDateNoTime.getTime() === filterLocalDateAtMidnight.getTime()) {
                        return 0;
                    }
                    return cellDateNoTime < filterLocalDateAtMidnight ? -1 : 1;
                },
            },
            valueFormatter: (params: any) => {
                if (!params.value) return "";
                const date = new Date(params.value);
                // format as DD/MM/YYYY for display
                const day = String(date.getDate()).padStart(2, "0");
                const month = String(date.getMonth() + 1).padStart(2, "0");
                const year = date.getFullYear();
                return `${day}/${month}/${year}`;
            },
        },
        {
            headerName: "Total GST Amount 1",
            field: "total_gst_amount_1",
            filter: "agNumberColumnFilter",
            enableValue: true,
            formatType: "AMOUNT"
        },
        {
            headerName: "Total GST Amount 2",
            field: "total_gst_amount_2",
            filter: "agNumberColumnFilter",
            enableValue: true,
            formatType: "AMOUNT"
        },
        {
            headerName: "Created On",
            field: "created_on",
            filter: "agDateColumnFilter",
            filterParams: {
                comparator: (filterLocalDateAtMidnight: any, cellValue: any) => {
                    if (!cellValue) return -1;
                    const cellDate = new Date(cellValue);
                    // Strip time part to compare only dates
                    const cellDateNoTime = new Date(
                        cellDate.getFullYear(),
                        cellDate.getMonth(),
                        cellDate.getDate()
                    );
                    if (cellDateNoTime.getTime() === filterLocalDateAtMidnight.getTime()) {
                        return 0;
                    }
                    return cellDateNoTime < filterLocalDateAtMidnight ? -1 : 1;
                },
            },
            valueFormatter: (params: any) => {
                if (!params.value) return "";
                const date = new Date(params.value);
                const day = String(date.getDate()).padStart(2, "0");
                const month = String(date.getMonth() + 1).padStart(2, "0");
                const year = date.getFullYear();
                return `${day}/${month}/${year}`;
            },
        },
        {
            headerName: "Reason",
            field: "reason",
            filter: "agTextColumnFilter",
            enableRowGroup: true,
            enablePivot: true
        },
        {
            headerName: "Matched By",
            field: "matched_by",
            filter: "agTextColumnFilter",
            enableRowGroup: true,
            enablePivot: true
        },
    ];

    const rowData = [
  {
    invoice_number: "INV-001",
    parsed_invoice_number: "INV-001-A",
    workspace: "Workspace 1",
    invoice_date: "2025-09-01",
    client_gst_number: "27AAACB1234F1Z1",
    hotel_gst_number: "27AAACH5678G1Z2",
    asset_link: "https://example.com/invoice/INV-001",
    checkout_date: "2025-09-05",
    total_gst_amount_1: 1500.75,
    total_gst_amount_2: 200.50,
    created_on: "2025-09-01",
    reason: "Initial Booking",
    matched_by: "John Doe"
  },
  {
    invoice_number: "INV-002",
    parsed_invoice_number: "INV-002-B",
    workspace: "Workspace 2",
    invoice_date: "2025-09-02",
    client_gst_number: "27AAACD9876F1Z3",
    hotel_gst_number: "27AAACH5432G1Z4",
    asset_link: "",
    checkout_date: "2025-09-06",
    total_gst_amount_1: 2500.00,
    total_gst_amount_2: 300.00,
    created_on: "2025-09-02",
    reason: "Follow-up",
    matched_by: "Jane Smith"
  }
];


    return (
        <>
           <PageHeader
           title="Ideation Portal"
           />
            <div style={{flex:1}}>
                <AgTableClient
                //@ts-ignore
                columnDefs={COLUMN_DEFS}
                rowData={rowData}
                groupPanel
                defaultPivot={[""]}
                grandTotalRow
                enablePDFViewer
                //showExport
                pinnedBottomRowData
            />
            </div>
        </>
    )
};

export default IdeationPortal;
